import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type WorkspaceIdentity } from '@modules/common/services/workspace-identity.service';

import { itemWorkspace, type WorkspaceItem } from './item-workspace-scope';

@Component({
  selector: 'app-item-workspace-footer',
  templateUrl: './item-workspace-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemWorkspaceFooterComponent {
  public readonly revision = input(0);
  public readonly identity = input<WorkspaceIdentity>();
  public readonly item = input<WorkspaceItem>();
  public readonly noun = input('');
  public readonly collection = input<string>();
  public readonly archived = input(false);
  public readonly deleted = input(false);
  protected readonly workspace = computed(() => {
    this.revision();
    return itemWorkspace(this.identity(), this.item());
  });
}
